import React, { useEffect } from "react";
import Layout from "../components/layout";
import EAHelmetSubcomp from "../components/EveryAction-helmet-subcomp";
import PrintButton from "../components/printbutton";
import { Link } from "gatsby"

const RegistrationPage = () => {
  return (
    <Layout>
     <div>
      <h1 style={{ textAlign: "center", marginTop: "10px" }}>
        Registrations Now Closed
      </h1>
      <p style={{ textAlign: "center", marginTop: "10px" }}>Online registration is now closed. You can still register for the conference in-person at the <a href="https://buffaloconvention.com/">Buffalo Convention Center</a>. If you have any questions regarding registrations please email rgiambrone@centerforinquiry.org or call 716-636-4869 ext. 300. </p>
      </div>
  
    </Layout>
  );
}

export default RegistrationPage;